(function () {
  const SLIDER_SELECTOR =
    ".cbb-also-bought-container .cbb-also-bought-slider, .cbb-also-bought-slider-container .cbb-also-bought-slider";

  function getProductScrollPosition(product, slider) {
    const sliderRect = slider.getBoundingClientRect();
    const productRect = product.getBoundingClientRect();
    return productRect.left - sliderRect.left + slider.scrollLeft;
  }

  function snapToNearestProduct(slider) {
    const products = slider.querySelectorAll(".cbb-also-bought-product");
    if (!products.length) return;

    const scrollLeft = slider.scrollLeft;
    const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    let targetScroll = 0;
    let minDistance = Infinity;

    products.forEach((product) => {
      const position = Math.min(getProductScrollPosition(product, slider), maxScroll);
      const distance = Math.abs(scrollLeft - position);

      if (distance < minDistance) {
        minDistance = distance;
        targetScroll = position;
      }
    });

    slider.style.scrollSnapType = "none";
    slider.scrollTo({ left: targetScroll, behavior: "smooth" });

    window.setTimeout(() => {
      slider.style.removeProperty("scroll-snap-type");
    }, 350);
  }

  function applyMomentum(slider, velocity, onComplete) {
    let speed = velocity * 16;

    const step = () => {
      if (Math.abs(speed) < 0.5) {
        onComplete();
        return;
      }

      slider.scrollLeft -= speed;
      speed *= 0.92;
      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }

  function initDragScroll(slider) {
    if (slider.dataset.dragScrollInit === "true") return;
    if (slider.scrollWidth <= slider.clientWidth) return;

    slider.dataset.dragScrollInit = "true";

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;
    let lastX = 0;
    let lastTime = 0;
    let velocity = 0;
    let startTarget = null;

    slider.addEventListener(
      "pointerdown",
      (event) => {
        if (event.pointerType === "touch") return;
        if (event.button !== 0) return;

        isDragging = true;
        moved = false;
        velocity = 0;
        startX = event.clientX;
        lastX = event.clientX;
        lastTime = performance.now();
        scrollLeft = slider.scrollLeft;
        slider.classList.add("is-dragging");
        slider.style.scrollSnapType = "none";
        slider.setPointerCapture(event.pointerId);
        startTarget = event.target;
      },
      { capture: true }
    );

    slider.addEventListener(
      "pointermove",
      (event) => {
        if (!isDragging) return;

        const now = performance.now();
        const delta = event.clientX - startX;
        const frameDelta = event.clientX - lastX;
        const elapsed = now - lastTime;

        if (Math.abs(delta) > 3) moved = true;
        if (!moved) return;

        if (elapsed > 0) {
          velocity = frameDelta / elapsed;
        }

        lastX = event.clientX;
        lastTime = now;
        event.preventDefault();
        slider.scrollLeft = scrollLeft - delta;
      },
      { passive: false }
    );

    const endDrag = (event) => {
      if (!isDragging) return;

      isDragging = false;
      slider.classList.remove("is-dragging");

      try {
        slider.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* pointer may already be released */
      }

      if (!moved) {
        slider.style.removeProperty("scroll-snap-type");
        if (startTarget) {
          const link = startTarget.closest("a, [data-href]");
          if (link) {
            if (startTarget.closest(".sm-product-card__icon-btns") || startTarget.closest("button")) {
              // Handled by pointerdown on the button
            } else {
              const href = link.getAttribute("href") || link.getAttribute("data-href");
              if (href && href !== "#") {
                window.location.href = href;
              } else {
                link.click();
              }
            }
          }
        }
        return;
      }

      const finishDrag = () => snapToNearestProduct(slider);

      if (Math.abs(velocity) > 0.05) {
        applyMomentum(slider, velocity, finishDrag);
      } else {
        finishDrag();
      }
    };

    slider.addEventListener("pointerup", endDrag);
    slider.addEventListener("pointercancel", endDrag);

    slider.addEventListener(
      "click",
      (event) => {
        if (!moved) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        moved = false;
      },
      true
    );
  }
  function initArrows(slider) {
    const container =
      slider.closest(".cbb-also-bought-container") ||
      slider.closest(".cbb-also-bought-slider-container") ||
      slider.parentElement;
    if (!container) return;

    // 已存在则跳过，避免 MutationObserver 反复重建
    let nav = container.querySelector(".cbb-also-bought-nav");
    if (nav) return;

    nav = document.createElement("div");
    nav.className = "cbb-also-bought-nav";
    nav.innerHTML =
      '<button type="button" class="cbb-nav-btn cbb-nav-prev" aria-label="Previous products">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
      "</button>" +
      '<button type="button" class="cbb-nav-btn cbb-nav-next" aria-label="Next products">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
      "</button>";
    container.appendChild(nav);

    const prev = nav.querySelector(".cbb-nav-prev");
    const next = nav.querySelector(".cbb-nav-next");

    // 每次翻一整屏（移动端正好 2 个，桌面端 3~4 个）
    const pageStep = () => Math.max(slider.clientWidth, 1);

    prev.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      slider.scrollBy({ left: -pageStep(), behavior: "smooth" });
    });

    next.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      slider.scrollBy({ left: pageStep(), behavior: "smooth" });
    });

    const update = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const noScroll = maxScroll <= 1;
      nav.classList.toggle("is-hidden", noScroll);
      prev.classList.toggle("is-disabled", noScroll || slider.scrollLeft <= 1);
      next.classList.toggle(
        "is-disabled",
        noScroll || slider.scrollLeft >= maxScroll - 1
      );
    };

    slider.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
    window.setTimeout(update, 500);
  }

  function initAll() {
     document.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => {
      initDragScroll(slider);
      initArrows(slider);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(
    window.debounce ? window.debounce(initAll, 200) : initAll
  );
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
